import { DescriptionText, H1Text, H2Text } from "../../../../design";
import React from "react";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";
import getformatteddate from "../../../../utils/getformatteddate";

type Props = {
  payment: Object,
  bankImageUrl: String,
}

const Header = (props: Props) => {
  const { payment, bankImageUrl } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo}>
      <H1Text>
        Add Payment Method
      </H1Text>
      <H2Text>
        Payment For
      </H2Text>
      <DescriptionText>
        {payment && payment.plan2 && payment.plan2.name}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {payment ? `${currencyformatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
      </DescriptionText>
      <H2Text>
        NEXT PLAN STARTS ON
      </H2Text>
      <DescriptionText>
        {payment && payment.plan2StartDate && getformatteddate(payment.plan2StartDate)}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
